/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Keys_SubtitleInputs */



/**
* | output |
* | --- |
* | "Manage your organization's API keys and access" |
*
* @param {Api_Keys_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const api_keys_subtitle = /** @type {((inputs?: Api_Keys_SubtitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Keys_SubtitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Verwalte die API-Schlüssel und den Zugriff deiner Organisation")
	return /** @type {LocalizedString} */ ("Manage your organization's API keys and access")
});